<template>
    <div class="container" :class="{ 'dark-mode': isDarkMode }">
        <div class="intro" data-aos="fade-down" data-aos-easing="ease-in-out" data-aos-duration="800"
            data-aos-anchor-placement="top">
            <p class="section_p1">Get To Know More</p>
            <h1 class="title"> About Me</h1>
        </div>

        <div class="section-container">
            <div class="about-img index" data-aos="fade-right" data-aos-easing="ease-in-out" data-aos-duration="950"
                data-aos-anchor-placement="top-center">
                <img src="" alt="Profile_Picture" class="about-pic">
            </div>
            <!-- <div class="details" data-aos="fade-left" data-aos-easing="ease-in" data-aos-duration="900" data-aos-anchor-placement="top"> -->
            <div class="details">
                <div class="about-container">
                    <div class="detail-container" v-for="(exp, index) in experienceData" :key="index">
                        <i :class="exp.icon"></i>
                        <h3>{{ exp.title }}</h3>
                        <p>{{ exp.years }}</p>
                        <p>{{ exp.info }}</p>
                        <p>{{ exp.certificate }}</p>
                    </div>
                </div>
                <div class="description">
                    <p>Hey there! I'm David and I work as a Web Developer and Programmer. My expertise lies in both Frontend
                        and Backend development, where I create websites that are interactive and user-friendly.
                        Over the couple of years I've had the opportunity to work on projects, which has helped me grow my
                        skills and keep up with the latest web technologies.
                        I absolutely enjoy transforming ideas into visually appealing websites, Coding is life itself.
                        I'm always thrilled to take on challenges and learn in this evolving world of web development.
                        If you're interested in collaborating feel free to reach out. I'd be more, than happy to connect
                        with you!
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'AboutMe',
    data() {
        return {
            experienceData: [
                { icon: 'fa-solid fa-award', title: 'Experience', years: '2+ Years', info: 'Frontend & Backend Developer' },
                { icon: 'fa-solid fa-user-graduate', title: 'Education', info: 'B.Sc. Computer Science', certificate: '2 Certificates' },
            ]
        }
    },

    computed: {
        ...mapState(['isDarkMode'])
    }
}
</script>

<style lang="scss" scoped>
.container {
    padding-top: 4vh;
    width: 100%;
    min-height: 100vh;
    height: 100%;
    box-sizing: border-box;


    .section-container {
        display: flex;
        flex-direction: row;
        height: 100%;
        margin: auto 0;
        gap: 4rem;


        .about-img {
            display: flex;
            justify-content: center;
            width: 100%;
            text-align: center;
            margin: auto;

            .about-pic {
                height: auto;
                max-width: 400px;
                border-radius: 2rem;
                align-items: center;
                text-align: center;
                box-shadow: 0 0 10px rgba(13, 0, 0, 1),
                    0px 0px 21px rgba(13, 0, 0, 0.078),
                    0px 0px 24px rgba(13, 0, 0, 0.082),
                    0px 1px 4px rgba(13, 0, 0, 0.016);
                transition: .5s ease-in;

                &:hover {
                    transform: scale(1.02);
                }
            }
        }

        .details {
            display: flex;
            justify-content: center;
            flex-direction: column;
            margin: 0 2.5rem;

            .about-container {
                display: flex;
                flex-direction: row;
                gap: 2rem;
                margin: 1rem 0;
                flex-wrap: wrap;
                width: 100%;


                .detail-container {
                    position: relative;
                    flex: 1;
                    text-align: center;
                    background: rgba(255, 255, 255, 0.164);
                    backdrop-filter: blur(9px);
                    border-radius: 2rem;
                    font-size: 1rem;
                    letter-spacing: 1px;
                    transition: .7s;
                    overflow: hidden;
                    z-index: 1;
                    padding: 1.5rem;

                    h3,
                    i {
                        color: black;
                    }


                    &::before {
                        content: "";
                        position: absolute;
                        top: 0;
                        left: 0;
                        background: black;
                        width: 0;
                        height: 100%;
                        z-index: -1;
                        transition: .3s;
                    }

                    &:hover::before {
                        width: 100%;
                    }

                    &:hover {

                        p,
                        h3,
                        i {
                            color: white;
                        }

                        box-shadow: 0 0 10px rgba(13, 0, 0, 1),
                        0px 0px 21px rgba(13, 0, 0, 0.078),
                        0px 0px 24px rgba(13, 0, 0, 0.082),
                        0px 1px 4px rgba(13, 0, 0, 0.016);

                        @media(max-width: 750px) {
                            box-shadow: 0 0 5px rgba(13, 0, 0, 1),
                            0px 0px 25px rgba(13, 0, 0, 0.6);
                        }
                    }
                }
            }

            .description {
                width: 100%;
                z-index: 99;

                p {
                    text-align: justify;
                    line-height: 2;
                    width: 100%;
                    font-size: 1.1rem;
                }
            }
        }

        @media (max-width: 1400px) {
            flex-direction: column;

            .about-img {
                // max-width:  250px;
                // height:  250px;

                .about-pic {
                    max-width: 250px;
                    height: 250px;
                }
            }
        }

        @media (max-width: 750px) {

            .details {
                margin: 0 .5rem;

                .about-container {
                    flex-direction: column;

                    .detail-container {
                        padding: 2rem 1.5rem;
                    }
                }

                .description {

                    p {
                        text-align: initial;
                        font-size: 1.05rem;
                    }
                }
            }
        }
    }
}

.dark-mode {
    .section-container {
        .about-img {
            .about-pic {
                box-shadow: 0 0 10px rgba(255, 255, 255, 1),
                    0 0 30px rgba(255, 255, 255, 0.6),
                    0 0 40px rgba(255, 255, 255, 0.4);
            }
        }

        .details {
            .about-container {
                .detail-container {
                    background: rgba(255, 255, 255, 0.164);
                    backdrop-filter: blur(9px);

                    h3,
                    i {
                        color: white;
                    }

                    &::before {
                        background: rgba(247, 247, 247, 0.897);
                    }

                    &:hover::before {
                        width: 100%;
                    }

                    &:hover {
                        p,
                        h3,
                        i {
                            color: rgb(32, 32, 32);
                        }

                        box-shadow: 0 0 10px rgba(255, 255, 255, 1),
                        0 0 21px rgba(255, 255, 255, 0.8),
                        0 0 24px rgba(255, 255, 255, 0.6),
                        0 0 4px rgba(255, 255, 255, 0.4);

                        @media(max-width: 750px) {
                            box-shadow: 0 0 8px rgba(255, 255, 255, 1),
                            0 0 25px rgba(255, 255, 255, 0.6);
                        }
                    }
                }
            }
        }
    }
}
</style>